module.exports = __webpack_public_path__ + "static/media/FormCheckbox_Unchecked.f441936a.svg";